import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { debounce } from 'lodash';
import {Input, Card, CardBody, Label, Button, Collapse, Modal, ModalHeader, ModalBody, ModalFooter, Alert} from 'reactstrap';

import RequiredLabel from '../../Components/RequiredLabel/RequiredLabel';
import UsersTable from '../../Components/UsersTable/UsersTable';
import Pager from '../../Components/Pager/Pager';
import Logic from '../../Logic';

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = 
        {
            query:'',

            modalOpended:false,
            users: null,
            filteredUsers:null,
            id: -1,
            requestorType: this.props.init.requestorTypes[0].Key,
            position: null,
            identityNumber: null,
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            vendors: [],
            liaison: null,
            options:[],
            pageSize: 10,
            validateNewUserData:['טופס ריק']
        };

        this.toggle = this.toggle.bind(this);
        this.clear = this.clear.bind(this);
        this.save = this.save.bind(this);
        this.onUserUpdate = this.onUserUpdate.bind(this);
        this.onUserDelete = this.onUserDelete.bind(this);
        this.getVendors = this.getVendors.bind(this);
        this.selectOption = this.selectOption.bind(this);
        this.removeVendor = this.removeVendor.bind(this);
        this.validateNewUserData = this.validateNewUserData.bind(this);

        this.getPage = this.getPage.bind(this);
        this.pageSizeChanged = this.pageSizeChanged.bind(this);
        this.pageChanged = this.pageChanged.bind(this);

        this.onQueryChanged = this.onQueryChanged.bind(this);
        this.debouncedGetPage = debounce(this.debouncedGetPage.bind(this), 200);
    }

    onQueryChanged(evt) {
        let edata = {id:evt.id, value: evt.target.value};
        this.setState({query:evt.target.value});
        this.debouncedGetPage(edata);
    }

    debouncedGetPage(edata){
        // console.log(edata);
        this.getPage(1, this.state.pageSize, edata.value);
    }

    // filterUsers(query){
    //     this.getPage(1, this.state.users.pageSize, query);
    // }
    
    componentDidMount(){
        this.getPage(1, 10, null);
    }

    toggle(){
        if(!this.state.modalOpended){
            this.setState(prevState => (
                {
                    modalOpended:true,
                    id: -1,
                    requestorType: this.props.init.requestorTypes[0].Key,
                    position: null,
                    identityNumber: null,
                    firstName : null,
                    lastName : null,
                    email: null,
                    phone: null,
                    vendors: [],
                    liaison: null,
                    options:[]
                }
            ));
        }else{
            this.setState(prevState => ({modalOpended:!prevState.modalOpended}));
        }
    }

    onUserUpdate(candidate){
        this.setState(prevState => ({
            modalOpended:true,
            id: candidate.id,
            firstName : candidate.firstName,
            lastName : candidate.lastName,
            identityNumber : candidate.identityNumber,
            email: candidate.email,
            phone: candidate.phone,
            vendors: candidate.vendors,
            liaison: candidate.liaison,
            requestorType: candidate.requestorType,
            position: candidate.position
        }));
    }

    onUserDelete(user){
        if(window.confirm('האם אתה בטוח שברצונך למחוק נאמן ביטחון זה?')){
            this.props.toggleSpinner();
            let logic = new Logic();
            logic.deleteUser(user, res => {
                alert(res.message);
                if(res.success){
                    this.setState({users:res.data});
                    this.clear();
                }else{
                    alert('אירעה שגיאה!');
                }
                this.props.toggleSpinner();
            });
        }
    }

    updateFormField(field, value, isNumbersOnly = false){
        let prev = this.state;
        if(!isNumbersOnly || (isNumbersOnly && value.match(/^\d*$/))){
            prev[field] = value;
            this.setState({...prev, validateNewUserData:this.validateNewUserData()});
        }
    }

    validateNewUserData(){
        let logic = new Logic();
        let res = [];
        const required = 'שדה חובה';
        const badIdentityNumber = 'תעודת זהות שגויה';
        const identityNumberLength = 'מספר תעודת הזהות חייב להיות 9 ספרות';
        if(!this.state.position){
            res.push('תפקיד ' + required);
        }

        if(!this.state.identityNumber){
            res.push('תעודת זהות ' + required);
        }

        if(this.state.identityNumber && !logic.validateIdentityNumber(this.state.identityNumber)){
            res.push(badIdentityNumber);
        }

        if(this.state.identityNumber && this.state.identityNumber.length !== 9){
            res.push(identityNumberLength);
        }

        if(!this.state.firstName){
            res.push('שם פרטי ' + required);
        }

        if(!this.state.lastName ){
            res.push('שם משפחה ' + required);
        }

        if(!this.state.email){
            res.push('דואר אלקטרוני ' + required);
        }

        if(!this.state.phone){
            res.push('מספר סלולרי ' + required);
        }

        if(this.state.phone && this.state.phone.match(/^0\d{9}$/) === null){
            res.push('נא להזין מספר סלולרי בן 10 ספרות, המתחיל ב-0');
        }

        if(!this.state.liaison){
            res.push('איש קשר במשרד הביטחון ' + required);
        }
        
        if(this.state.vendors.length === 0){
            res.push('אנא בחר ספק אחד לפחות מתוך רשימת הספקים');
        }

        // console.log(res);

        return res;
    }

    save(){
        let validation = this.validateNewUserData();
        if(validation.length === 0){
            let logic = new Logic();
            this.props.toggleSpinner();
            logic.saveUser(this.state.id, this.state.position, this.state.requestorType, this.state.identityNumber, this.state.firstName, this.state.lastName, this.state.email, this.state.phone, this.state.vendors, this.state.liaison, (res) => { //logic.pad(this.state.identityNumber, 9, '0')
                if(res.success){
                    alert(res.message);
                    this.setState({users:res.data});
                    this.toggle();
                    this.clear();
                }else{
                    alert(res.message);
                }
                this.props.toggleSpinner();
            });
        }else
        {
            alert()
        }
    }

    clear(){
        this.setState( 
        {
            id: -1,
            requestorType: this.props.init.requestorTypes[0].Key,
            position: null,
            firstName : null,
            lastName : null,
            identityNumber : null,
            email: null,
            phone: null,
            vendors: [],
            liaison: null
        }, () => {
            this.setState({validateNewUserData:this.validateNewUserData()});
        });
    }

    getVendors(query){
        if(query && query.trim().length > 2){
            let logic = new Logic();
            logic.getVendors(query, (data) =>{
                this.setState({options:data});
            });
        }else if(!query || query.trim().length === 0){
            this.setState({options:[]});
        }
    }

    selectOption(option){
        if(this.state.vendors.map(a => a.Key).indexOf(option.Key) === -1){ //do not add twice the same option
            let vendors = [...this.state.vendors, option];
            this.setState({vendors:vendors, options:[]}, ()=>{
                this.setState({validateNewUserData:this.validateNewUserData()})
            });
            document.getElementById('txtVendorQuery').value = null;
        }
    }

    removeVendor(vendor){
        if(window.confirm('האם אתה בטוח שברצונך להסיר את הספק ' + vendor.Value + ' מניהולו של נאמן הביטחון?')){
            let vendors = [...this.state.vendors];
            vendors = vendors.filter(v => v.Value !== vendor.Value);
            // vendors.pop(vendor);
            this.setState({vendors:vendors}, ()=> { this.setState({validateNewUserData:this.validateNewUserData()})});
        }
    }

    getPage(pageNumber, pageSize, query){
        let logic = new Logic(this.props.init);
        logic.getTablePage('Admin/GetUsers', pageNumber, pageSize, query, (page) => {
            console.log('filtered users', page);

            let prevUsers = {...this.state.users};
            prevUsers.totalRows = 0;
            prevUsers.totalPages = 0;
            prevUsers.rows = [];
            // console.log('prevUsers', prevUsers);

            this.setState({users: {...prevUsers}});
            this.setState({users: {...page}});
            // this.setState(prevState => { 
            //     return {
            //         ...prevState,
            //         users: {...data}
            //     }}
            // );
        })
    }

    pageSizeChanged(pageSize){
        this.setState({...this.state, pageSize});
        this.getPage(1, pageSize, this.state.query);
    }

    pageChanged(pageNumber){
        this.getPage(pageNumber, this.state.users.pageSize, this.state.query);
    }

    render(){
        return (
            <div className="col-xs-12">
                {this.props.init ?
                <>
                    <div style={{padding:'1rem'}}>
                        <h1>רשימת נאמני ביטחון</h1>
                        <div style={{marginTop:'1rem', marginBottom:'1rem'}}>
                            <Button color="primary" style={{margin:'0rem 0rem 1rem 0', float:'right'}} onClick={this.toggle} className="col-sm-5 col-md-2 d-block d-md-none"><FontAwesome name="user-plus"/> צור נאמן ביטחון חדש</Button>
                            <Button color="primary" style={{margin:'0rem 0rem 1rem 0', float:'left'}} onClick={this.toggle} className="col-sm-5 col-md-2 d-none d-md-block"><FontAwesome name="user-plus"/> צור נאמן ביטחון חדש</Button>
                            
                            {this.state.users ? 
                            <>
                                <input type="text" style={{border:'1px solid #EAEDF8', borderRadius:'40px', position:'initial', outline:'0', padding:'8px 20px 8px 8px'}} className="col-sm-12 col-md-3 float-right" id="txtFilter" placeholder="סינון לפי שם, מייל, תז, ספק, מספר ספק או טלפון" value={this.state.query || ''} onChange={this.onQueryChanged}/>
                                <FontAwesome name="search" style={{marginRight:'-30px', marginTop:'15px'}} className="float-right"/>
                            </> : null }
                            <div style={{clear:'both'}}></div>
                        </div>
                    </div>  
                    
                    <Modal isOpen={this.state.modalOpended} toggle={this.toggle}>
                        <ModalHeader className="modal-close" toggle={this.toggle}>יצירת נאמן ביטחון חדש</ModalHeader>
                        <ModalBody>

                            <h5>פרטי נאמן ביטחון</h5>
                            <br/>
                            <div className="form-inline">
                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>תעודת זהות</RequiredLabel>
                                    <Input type="text" placeholder="תעודת זהות" value={this.state.identityNumber || ''} onChange={evt => this.updateFormField('identityNumber', evt.target.value)} />
                                </div>

                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>שם פרטי</RequiredLabel>
                                    <Input type="text" placeholder="שם פרטי" value={this.state.firstName || ''} onChange={evt => this.updateFormField('firstName', evt.target.value)} />
                                </div>

                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>שם משפחה</RequiredLabel>
                                    <Input type="text" placeholder="שם משפחה" value={this.state.lastName || ''} onChange={evt => this.updateFormField('lastName', evt.target.value)} />
                                </div>
                            </div>

                            <div className="form-inline">
                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>תפקיד</RequiredLabel>
                                    <Input type="text" placeholder="תפקיד" value={this.state.position || ''} onChange={evt => this.updateFormField('position', evt.target.value)} />
                                </div>

                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>כתובת דואר אלקטרוני</RequiredLabel>
                                    <Input type="text" placeholder="כתובת דואר אלקטרוני" value={this.state.email || ''} onChange={evt => this.updateFormField('email', evt.target.value)}/>
                                </div>

                                <div className="col-xs-12 col-md-4">
                                    <RequiredLabel style={{display:'block'}}>מספר סלולרי</RequiredLabel>
                                    <Input type="text" placeholder="טלפון סלולרי" value={this.state.phone || ''} onChange={evt => this.updateFormField('phone', evt.target.value, true)}/>
                                </div>
                            </div>

                            <br/><br/>

                            <h5>קשר למשרד הביטחון</h5>
                            <br/>
                            <div className="form-inline">
                                <div className="col-xs-12 col-md-6">
                                    <RequiredLabel style={{display:'block'}}>סוג גורם מבקש</RequiredLabel>
                                    <select className="form-control" value={this.state.requestorType || this.props.init.requestorTypes[0].Key} onChange={evt => this.updateFormField('requestorType', evt.target.value)}>
                                    {this.props.init.requestorTypes.map(a => <option value={a.Key} key={a.Key}>{a.Value}</option>)}
                                    </select>
                                </div>

                                <div className="col-xs-12 col-md-6">
                                    <RequiredLabel style={{display:'block'}}>איש קשר במשרד הביטחון</RequiredLabel>
                                    <Input type="text" placeholder="איש קשר ואגף האחראי על נאמן הביטחון" value={this.state.liaison || ''} onChange={evt => this.updateFormField('liaison', evt.target.value)}/>
                                </div>
                            </div>

                            <div style={{marginTop:'20px'}} className="col-xs-12">
                                <Card>
                                    <CardBody>
                                        <RequiredLabel>ספקים המקושרים לנאמן הביטחון</RequiredLabel>
                                        {this.state.vendors.length > 0 ? 
                                        this.state.vendors.map((a,i) => (<div key={i} style={{clear:'both'}}><div style={{float:'right'}}>{i+1}. {a.Value} - {a.Key}</div> <div style={{float:'left', cursor:'pointer'}} color="link" onClick={(event) => this.removeVendor(a)} className="text-danger"><FontAwesome name="times" /></div></div>))
                                        : <div className="text-danger">אין ספקים המקושרים לנאמן ביטחון זה</div>}

                                        <br/>
                                        <br/>

                                        <Label>הוספת ספק</Label>
                                        <Input type="text" placeholder="איתור ספק לפי שם או מספר" id="txtVendorQuery" onChange={evt => this.getVendors(evt.target.value)}/>
                                        {this.state.options.length > 0 ? 
                                        <div className={"dropdown-menu col-sm-12"} style={{clear:'both', padding:'0', top:'initial', display:'block', margin:'0', width:'90%', marginRight:'5%'}}> 
                                            {this.state.options.map(option => <a style={{borderBottom: '1px solid rgba(0,0,0,0.1)'}} className="dropdown-item" onClick={(event) => this.selectOption(option)} key={option.Key}>{option.Value}</a>)} 
                                        </div> : null}
                                    </CardBody>
                                </Card>
                            </div>
                            
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.clear}><FontAwesome name="times"/> נקה</Button>
                            <Button color="primary" disabled={this.state.validateNewUserData.length !== 0} onClick={this.save} style={{marginRight:'20px'}}><FontAwesome name="check"/> שמור</Button>
                        </ModalFooter>
                    </Modal>

                    <div style={{marginTop:'20px'}}>
                        {this.state.users ? 
                        <>
                            <UsersTable init={this.props.init} users={this.state.users.rows} onUserDelete={this.onUserDelete} onUserUpdate={this.onUserUpdate}/>
                            {this.state.users.rows.length > 0 ?
                                <Pager totalRows={this.state.users.totalRows} pageSizes={this.state.users.pageSizes} onPageChanged={this.pageChanged} onPageSizeChanged={this.pageSizeChanged} currentPage={this.state.users.currentPage} totalPages={this.state.users.totalPages} pageSize={this.state.users.pageSize}/>
                            : null}
                        </> : 
                        <Alert color="info" className="col-md-3 mx-auto">אנא המתן, לטעינת נאמני הבטחון</Alert> }
                    </div>
                </> : null}
            </div>
        );
    }
  };
  
export default Users;